module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAWCAYAAADJqhx8AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAACXSURBVHgB7VExDsMgDMRhBKR2grFP6I+6du3YsT/rE9oXtBvKFAZ2cpYYoihE3rJwC8fZHJZPhxBuxpi3c+5urU05568CpDpB+EG/cJGIUozxXBtF+lBKOakK8LTgIl1jlBH8igs7PjHqh4tSXR0O3VPoKfQU9sHb9t5PvDTmrT7aMdhMYY2hZdBKQWyAXx84/vXxq9U3A2Fw7Bhp3FSmAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dashboard.png
// module id = 4K3T
// module chunks = 0